<div class="button-container">
  <button
    *ngFor="let option of options"
    type="button"
    class="button"
    [ngClass]="getNgClass(option)"
    (click)="handleClick(option)"
  >
    {{ option.name }}
  </button>
</div>
